export const ErrorComment = (json: IErrorComment): IErrorCommentModel => ({
	id: json.id,
	content: json.comment,
	authorName: json.author_name,
	mesId: json.mes_id,
	createdAt: json.created_at,
	origin: json.origin ?? (json.mes_id ? 'mes' : 'crm'),
	readAtMes: json.read_at_mes ?? null,
	readAtCrm: json.read_at_crm ?? null,
})

const resolveViewPayload = (json: IRecipeError): string | null =>
	typeof json.view_payload === 'object' && json.view_payload !== null
		? JSON.stringify(json.view_payload)
		: (json.view_payload ?? null)

const resolveAssignedName = (json: IRecipeError): string | null => {
	const employee = json.assigned_to_employee
	if (!employee) return null
	return `${employee.first_name} ${employee.last_name}`.trim() || employee.email
}

const mapRecipeErrorIdentity = (json: IRecipeError) => ({
	id: json.id,
	facilityIdentifier: json.facility_identifier,
	recipeId: json.recipe_id ?? null,
	recipeName: json.recipe_name ?? null,
	mealIds: json.meal_ids ?? [],
	mealNames: json.meal_names ?? [],
	socketId: json.socket_id ?? null,
	socketName: json.socket?.name ?? null,
	productId: json.product_id ?? null,
	productName: json.product_name ?? null,
	variantId: json.variant_id ?? null,
	variantName: json.variant_name ?? null,
	productionPlanId: json.production_plan_id ?? null,
})

const mapRecipeErrorDetails = (json: IRecipeError) => ({
	reporterName: json.reporter_name,
	description: json.description,
	type: json.type,
	status: json.status,
	statusChangedByEmployeeId: json.status_changed_by_employee_id ?? null,
	statusChangedAt: json.status_changed_at ?? null,
	reportedAt: json.reported_at,
	productionDay: json.production_day ?? null,
	viewPayload: resolveViewPayload(json),
	comments: json.comments?.map(ErrorComment) ?? [],
	assignedToEmployeeName: resolveAssignedName(json),
	instructionsPreviewImg: json.instructions_preview_img ?? null,
	issueImg: json.issue_img ?? null,
	requiresAttention: json.requires_attention ?? null,
	unreadCommentsForMes: json.unread_comments_for_mes ?? 0,
	unreadCommentsForCrm: json.unread_comments_for_crm ?? 0,
})

export const toRecipeErrorModel = (json: IRecipeError): IRecipeErrorModel => ({
	...mapRecipeErrorIdentity(json),
	...mapRecipeErrorDetails(json),
})
